/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerRemoveMutationResponse, ComparisonsControllerRemovePathParams } from "../../models/comparisonsController/ComparisonsControllerRemove";

function getComparisonsControllerRemoveUrl(id: ComparisonsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/comparisons/${id}` as const }  
  return res
}

/**
 * @summary Delete a comparison by ID
 * {@link /api/v1/comparisons/:id}
 */
export async function comparisonsControllerRemove(id: ComparisonsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerRemoveMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getComparisonsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}